import React, { useState } from "react";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import MenuIcon from "../../../../../assets/disabilityIcons/Menu.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import CollapseableTable from "../../components/collapseAbleTable/CollapseableTable";
import { Table } from "antd";
import useGetAttributes from "../../hooks/useGetAttributes";
import useCreateAttribute from "../../hooks/useCreateAttribute";
import UseUpdate from "../../hooks/UseUpdate";
import useDeleteItem from "../../hooks/useDeleteItem";
import useFetchItems from "../../hooks/useFetchItems";
import useFetchContacts from "../../hooks/useFetchContacts";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { getAllColumns } from "./AllColumsData";
import useModalHandlers from "../../hooks/useModalHandler";
import useChangeHandler from "../../hooks/useChangeHandler";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import { MODULE_API } from "../../../../../apis";
import axios from "axios";
import useUploadDocument from "../../hooks/useUploadDocument";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

const MODULE_NAMES = [
  "Insurance Products",
  "Property Documentation",
  "Agent Contact Information",
  "PROPERTY",
  "Property Tax Records",
  "Mortgage Information",
];

export default function PropertyDocumentation() {
  const [loading, setLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [moduleName, setModuleName] = useState("Property Documentation");
  const [formData, setFormData] = useState(null);
  const [attributesData, setAttributesData] = useState(null);
  const {
    errorState,
    fetchData,
    fieldsData,
    disasterAttributeData,
    loadingState,
    formatModuleKey,
    setTableData,
    setToUpdate,
    toUpdate,
    tableData,
  } = useFetchItems(MODULE_NAMES, setLoading);
  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { updateRecord } = UseUpdate(
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { deleteRecord } = useDeleteItem(
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { attributes, disasterAttribute } = useGetAttributes(MODULE_NAMES, setLoading);

  const { contactList } = useFetchContacts(setLoading);

  const { showModal, updateModal, viewModal, handelCloseModal } =
    useModalHandlers(
      attributes,
      setModalTitle,
      setModuleName,
      setIsModalVisible,
      setFormData,
      setAttributesData
    );
  const { handleChange, handleItemsInfoSelect } = useChangeHandler(setFormData);

  const { handleImageUpload } = useUploadDocument(setLoading, setFormData);
  

  const history = useHistory();

  const AddContact = () => {
    history.push("/client/plan");
  };
  const AddInsurance = () => {
    history.push("/insurance_new");
  };
  const Addinventory = () => {
    history.push("/inventory_new");
  };
  const AddDocument = () => {
    history.push("/organizer/important-document");
  };
  const collapseableTables = [
    { title: "Property Insurance Information", key: 1, OnClick: AddInsurance },
    { title: "Agent Contact Information", key: 2, OnClick: AddContact },
    { title: "Inventory", key: 3, OnClick: Addinventory },
  ];
  const recordsTable = [
    { title: "Property Tax Records", key: 4 },
    { title: "Mortgage Information", key: 5 },
  ];

  const tableDataObj = {
    "Property Insurance Information":
      tableData.insuranceProductsData,
    "Property Documentation": tableData.propertyDocumentationData,
    "Agent Contact Information": tableData.agentContactInformationData,
    "Property Tax Records": tableData.propertyTaxRecordsData,
    "Inventory": tableData.pROPERTYData,
    "Mortgage Information": tableData.mortgageInformationData,
  };

  const AllColumnsData = getAllColumns(viewModal, updateModal, deleteRecord);

  const handleFormDataUpdate = (formData) => {
    const Payload = {
      "Name": formData && formData.name,
      "Phone Number": formData && formData.phoneNumber,
      "Company":formData && formData.jobCompany,
    };

    console.log("Payload to update formData property Documents:", Payload);

    setFormData((prev) => ({
      ...prev,
      ...Payload,
    }));
  };

  return (
    <div style={{ position: "relative" }}>
      <div className="parent-title-container">
      <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
        <h2 className="parent-title">Property Documentation</h2>
        <ToolTipCreator name={"Disaster_Property_Documentation"}/>
      </div>
        {/* <div className="parent-icon-container">
          <img
            src={helpIcon}
            alt="help icon"
            width="18.67px"
            height="18.67px"
          />
        </div> */}
      </div>
      {disasterAttribute && (
        <>
          <DisabilityFormCreator
            data={disasterAttribute && disasterAttribute}
            values={disasterAttributeData}
            setSubmitBody={setFormData}
          />
          <div className="handle-submit-button-container">
            <button
              className="submit-button"
              onClick={async () => {
                if (toUpdate) {
                  await updateRecord();
                } else {
                  await createAttributes();
                }
              }}
            >
              {toUpdate ? "Update" : "Submit"}
            </button>
          </div>
        </>
      )}
      {collapseableTables.map((table, idx) => (
        <CollapseableTable
          title={table.title}
          key={table.key}
          setFormData={setFormData}
          formData={formData}
          setModuleName={setModuleName}
          handleFormDataUpdate={handleFormDataUpdate}
          createAttributes={createAttributes}
          options={contactList}
          onClick={() =>
            ["Property Insurance Information", "Agent Contact Information", "Inventory"].includes(table.title)
              ? table.OnClick()
              : showModal(table.title)
          }
        >
          <Table
            columns={AllColumnsData[table.title]}
            dataSource={tableDataObj[table.title]}
          />
        </CollapseableTable>
      ))}
{recordsTable.map((table, idx) => (
  <CollapseableTable
    title={table.title}
    key={table.key}
    setFormData={setFormData}
    formData={formData}
    setModuleName={setModuleName}
    handleFormDataUpdate={handleFormDataUpdate}
    createAttributes={createAttributes}
    updateModal={updateModal}
    viewModal={viewModal}
    onClick={() => showModal(table.title)}
    options={contactList}
  >
    <Table
      columns={AllColumnsData && AllColumnsData[table.title]}
      dataSource={tableDataObj[table.title]}
    />
  </CollapseableTable>
))}

<CustomModal
  show={isModalVisible}
  fields={attributesData && attributesData}
  modalTitle={modalTitle}
  close={handelCloseModal}
  onChange={handleChange}
  onSelectChange={handleItemsInfoSelect}
  submitData={modalTitle !== "Update" ? createAttributes : updateRecord}
  selectedRowData={formData && formData}
  handleItemsInfoImageChange={handleImageUpload}
  loading={loadingState}
/>

<NewLoader isLoading={loading} />

    </div>
  );
}
